import { render } from "./CurrencySelector.vue?vue&type=template&id=e63a34c0&ts=true"
import script from "./CurrencySelector.vue?vue&type=script&lang=ts"
export * from "./CurrencySelector.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__